export const DEFAULT_HUE = 60

export const INCREMENTS = [12, 25, 38, 50, 62, 75, 88, 100]

/**
 * Hue range input step size
 */
export const HUE_STEP = 5

/**
 * Minimum hue allowed by range input
 */
export const MIN_HUE = 0

/**
 * Maximum hue allowed by range input
 */
export const MAX_HUE = 355
